import DimensionDO = App.Data.DimensionDO;

const PERIOD_TYPE = "datetime";
const SEGMENT_TYPE = "segment";

const isPeriod = (dimension: DimensionDO) => dimension.type === PERIOD_TYPE;
const isSegment = (dimension: DimensionDO) => dimension.type === SEGMENT_TYPE;
const isCategorical = (dimension: DimensionDO) =>
	!isPeriod(dimension) && !isSegment(dimension);

/**
 * Which kinds of dimension a segment part can be filtered on, by the data
 * source it is built from. Carried over from the tabs the filter drawer used to
 * show: occupancy parts took categorical and period filters, customer parts
 * took categorical only, and a segment part took other segments.
 */
const accepts = (
	dataSource: string
): ((dimension: DimensionDO) => boolean) | null => {
	if (dataSource === "segment") {
		return isSegment;
	}

	if (dataSource === "tab_occ_prk_v") {
		return (dimension) => isCategorical(dimension) || isPeriod(dimension);
	}

	return dataSource === "tab_cus_v" ? isCategorical : null;
};

/**
 * Outside expert mode every dimension is on offer; expert mode narrows the list
 * to the ones the chosen data source actually carries.
 */
export const dimensionsForSegmentFilter = (
	dimensions: DimensionDO[],
	{
		dataSource,
		isExpertMode = false,
	}: { dataSource: string; isExpertMode?: boolean }
): DimensionDO[] => {
	const accepted = accepts(dataSource);

	if (accepted === null) {
		return [];
	}

	const scoped = isExpertMode
		? dimensions.filter((dimension) =>
				dimension.available_for_data_source?.includes(dataSource)
		  )
		: dimensions;

	return scoped.filter(accepted);
};
